// src/components/elements/Building.js
import React, { useState } from 'react';
import './BuildingStyles.css';

export const Building = ({ 
  id, 
  x, 
  y, 
  width, 
  height, 
  color, 
  type, 
  properties,
  onRotate,
  onDelete 
}) => {
  const [orientation, setOrientation] = useState(0);
  const setbackDistance = (properties.setback || 0) * 5;
  
  const handleRotateClick = (e) => {
    e.stopPropagation();
    const newOrientation = (orientation + 90) % 360;
    setOrientation(newOrientation);
    onRotate(id, newOrientation);
  };

  const renderWindows = () => {
    const windowSize = 15;
    const windowSpacing = 30;
    const windowRows = Math.floor((height - setbackDistance * 2) / windowSpacing);
    const windowCols = Math.floor((width - setbackDistance * 2) / windowSpacing);
    
    return Array(windowRows).fill().map((_, row) => (
      Array(windowCols).fill().map((_, col) => (
        <div
          key={`window-${row}-${col}`}
          className="building-window"
          style={{
            left: setbackDistance + col * windowSpacing + windowSpacing/2,
            top: setbackDistance + row * windowSpacing + windowSpacing/2,
            width: windowSize,
            height: windowSize
          }}
        />
      ))
    ));
  };

  const renderRoof = () => {
    if (properties.maxFloors > 4) {
      return (
        <div className="building-roof">
          <div className="roof-detail" />
        </div>
      );
    }
    return <div className="building-roof sloped" />;
  };

  const renderEntrance = () => (
    <div className="building-entrance">
      <div className="entrance-door" />
      <div className="entrance-steps" />
    </div>
  );

  const renderSpecialFeatures = () => {
    const features = [];
    
    if (properties.hasHelicopter) {
      features.push(
        <div key="helipad" className="helipad">
          <div className="helipad-circle">H</div>
          <div className="helipad-markings" />
        </div>
      );
    }

    if (properties.hasPlayground) {
      features.push(
        <div key="playground" className="playground">
          <div className="playground-equipment" />
          <div className="playground-surface" />
        </div>
      );
    }

    if (properties.hasLoadingBay) {
      features.push(
        <div key="loading" className="loading-bay">
          <div className="loading-dock" />
          <div className="loading-ramp" />
        </div>
      );
    }

    return features;
  };

  const renderPropertyBadges = () => {
    const badges = [
      { key: 'maxFloors', icon: '🏢', text: `${properties.maxFloors || 1}F` },
      { key: 'hasParking', icon: '🅿️' },
      { key: 'hasEmergencyAccess', icon: '🚑' },
      { key: 'requiresQuietZone', icon: '🤫' },
      { key: 'hasWaterFeature', icon: '💧' },
      { key: 'supportsEvents', icon: '🎪' }
    ].filter(badge => properties[badge.key]);

    return (
      <div className="property-badges">
        {badges.map(badge => (
          <span key={badge.key} className="property-badge" title={badge.key}>
            {badge.icon} {badge.text}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div
      className="building"
      style={{
        position: 'absolute',
        left: x,
        top: y,
        width,
        height,
        transform: `rotate(${orientation}deg)`,
        transformOrigin: 'center'
      }}
    >
      <div className="building-label">
        {type}
        {renderPropertyBadges()}
      </div>

      <div className="setback" style={{
        border: `${setbackDistance}px solid rgba(0, 0, 0, 0.1)`
      }} />
      
      <div className="building-main" style={{
        left: setbackDistance,
        top: setbackDistance,
        width: `calc(100% - ${setbackDistance * 2}px)`,
        height: `calc(100% - ${setbackDistance * 2}px)`,
        backgroundColor: color
      }}>
        {renderWindows()}
        {renderEntrance()}
        {renderRoof()}
        {renderSpecialFeatures()}
      </div>

      <button className="rotate-button" onClick={handleRotateClick}>⟳</button>
      <button className="delete-button" onClick={(e) => { e.stopPropagation(); onDelete(id); }}>×</button>
    </div>
  );
};